export const ContactEndpoints = {
  list: '/search/contact',
};
